/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import type React from 'react';
import { createContext, useContext } from 'react';

type FormFieldGroupControlType = 'checkbox' | 'radio';

type FormFieldGroupContextValue = {
  controlType: FormFieldGroupControlType;
  name?: string;
  isDisabled: boolean;
  isRequired: boolean;
  hasError: boolean;
  /** Selected radio value when the group is controlled. `null` means no selection. */
  value?: string | null;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FormFieldGroupContext = createContext<FormFieldGroupContextValue | null>(
  null,
);

const useFormFieldGroup = (controlType: FormFieldGroupControlType) => {
  const context = useContext(FormFieldGroupContext);

  return context?.controlType === controlType ? context : undefined;
};

export {
  FormFieldGroupContext,
  type FormFieldGroupContextValue,
  useFormFieldGroup,
};
